var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"will-change-transform",style:({ transform: `translateX(${_vm.dragDistance}px)` }),on:{"touchstart":_vm.handleTouchStart,"touchmove":_vm.handleTouchMove,"touchend":_vm.resetPosition}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }